module.exports = __webpack_public_path__ + "img/Hesburger-Logo.3a39da5e.png";